/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MTG Label Generator
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApiCardTypesApiCardTypesGet200,
  MTGSetResponse
} from '../../model';

import { customFetch } from '../../client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type apiSetsApiSetsGetResponse200 = {
  data: MTGSetResponse[]
  status: 200
}

export type apiSetsApiSetsGetResponseSuccess = (apiSetsApiSetsGetResponse200) & {
  headers: Headers;
};
;

export type apiSetsApiSetsGetResponse = (apiSetsApiSetsGetResponseSuccess)

export const getApiSetsApiSetsGetUrl = () => {




  return `/api/sets`
}

/**
 * API endpoint to get filtered sets.
 *
 * Returns:
 *     List of filtered set dictionaries
 * @summary Api Sets
 */
export const apiSetsApiSetsGet = async ( options?: Parameters<typeof customFetch>[1]): Promise<apiSetsApiSetsGetResponse> => {

  return customFetch<apiSetsApiSetsGetResponse>(getApiSetsApiSetsGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getApiSetsApiSetsGetQueryKey = () => {
    return [
    `/api/sets`
    ] as const;
    }


export const getApiSetsApiSetsGetQueryOptions = <TData = Awaited<ReturnType<typeof apiSetsApiSetsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSetsApiSetsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiSetsApiSetsGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSetsApiSetsGet>>> = ({ signal }) => apiSetsApiSetsGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiSetsApiSetsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiSetsApiSetsGetQueryResult = NonNullable<Awaited<ReturnType<typeof apiSetsApiSetsGet>>>
export type ApiSetsApiSetsGetQueryError = unknown


export function useApiSetsApiSetsGet<TData = Awaited<ReturnType<typeof apiSetsApiSetsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSetsApiSetsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiSetsApiSetsGet>>,
          TError,
          Awaited<ReturnType<typeof apiSetsApiSetsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiSetsApiSetsGet<TData = Awaited<ReturnType<typeof apiSetsApiSetsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSetsApiSetsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiSetsApiSetsGet>>,
          TError,
          Awaited<ReturnType<typeof apiSetsApiSetsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiSetsApiSetsGet<TData = Awaited<ReturnType<typeof apiSetsApiSetsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSetsApiSetsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Api Sets
 */

export function useApiSetsApiSetsGet<TData = Awaited<ReturnType<typeof apiSetsApiSetsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSetsApiSetsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiSetsApiSetsGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type apiCardTypesApiCardTypesGetResponse200 = {
  data: ApiCardTypesApiCardTypesGet200
  status: 200
}

export type apiCardTypesApiCardTypesGetResponseSuccess = (apiCardTypesApiCardTypesGetResponse200) & {
  headers: Headers;
};
;

export type apiCardTypesApiCardTypesGetResponse = (apiCardTypesApiCardTypesGetResponseSuccess)

export const getApiCardTypesApiCardTypesGetUrl = () => {




  return `/api/card-types`
}

/**
 * API endpoint to get card types organized by color.
 *
 * Returns:
 *     Dictionary mapping color names to lists of card types
 * @summary Api Card Types
 */
export const apiCardTypesApiCardTypesGet = async ( options?: Parameters<typeof customFetch>[1]): Promise<apiCardTypesApiCardTypesGetResponse> => {

  return customFetch<apiCardTypesApiCardTypesGetResponse>(getApiCardTypesApiCardTypesGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getApiCardTypesApiCardTypesGetQueryKey = () => {
    return [
    `/api/card-types`
    ] as const;
    }


export const getApiCardTypesApiCardTypesGetQueryOptions = <TData = Awaited<ReturnType<typeof apiCardTypesApiCardTypesGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiCardTypesApiCardTypesGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiCardTypesApiCardTypesGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiCardTypesApiCardTypesGet>>> = ({ signal }) => apiCardTypesApiCardTypesGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiCardTypesApiCardTypesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiCardTypesApiCardTypesGetQueryResult = NonNullable<Awaited<ReturnType<typeof apiCardTypesApiCardTypesGet>>>
export type ApiCardTypesApiCardTypesGetQueryError = unknown


export function useApiCardTypesApiCardTypesGet<TData = Awaited<ReturnType<typeof apiCardTypesApiCardTypesGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiCardTypesApiCardTypesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiCardTypesApiCardTypesGet>>,
          TError,
          Awaited<ReturnType<typeof apiCardTypesApiCardTypesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiCardTypesApiCardTypesGet<TData = Awaited<ReturnType<typeof apiCardTypesApiCardTypesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiCardTypesApiCardTypesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiCardTypesApiCardTypesGet>>,
          TError,
          Awaited<ReturnType<typeof apiCardTypesApiCardTypesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiCardTypesApiCardTypesGet<TData = Awaited<ReturnType<typeof apiCardTypesApiCardTypesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiCardTypesApiCardTypesGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Api Card Types
 */

export function useApiCardTypesApiCardTypesGet<TData = Awaited<ReturnType<typeof apiCardTypesApiCardTypesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiCardTypesApiCardTypesGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiCardTypesApiCardTypesGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






